import React from "react";
import { useTranslation } from "react-i18next";
import BackArrowButton from "../parts/back-arrow-button";
import LoginWrapper from "./LoginWrapper";
import OnboardingRadio from "../parts/inputs/onboarding-radio";

function SignupParqView(props) {
  const { t } = useTranslation("auth");
  const [error, setError] = React.useState("");
  const {
    onBack,
    handleParqInfo,
    handleFieldChange,
    heartCondition,
    chestPain,
    pastMonthChestPain,
    dizzinesConsciousnessLoss,
    boneJointProblem,
    bloodPressurePrescription,
    reasonForNoPhysicalAct,
  } = props;

  React.useEffect(() => {
    document.querySelector('input[name="heartCondition"]')?.focus();
  }, []);

  const QUESTIONS = [
    { questionKey: "heartCondition", name: "heartCondition", value: heartCondition },
    { questionKey: "chestPain", name: "chestPain", value: chestPain },
    {
      questionKey: "pastMonthChestPain",
      name: "pastMonthChestPain",
      value: pastMonthChestPain,
    },
    {
      questionKey: "dizziness",
      name: "dizzinesConsciousnessLoss",
      value: dizzinesConsciousnessLoss,
    },
    {
      questionKey: "boneJointProblem",
      name: "boneJointProblem",
      value: boneJointProblem,
    },
    {
      questionKey: "bloodPressurePrescription",
      name: "bloodPressurePrescription",
      value: bloodPressurePrescription,
    },
    {
      questionKey: "reasonNoActivity",
      name: "reasonForNoPhysicalAct",
      value: reasonForNoPhysicalAct,
    },
  ];

  const changeQuestionValue = (event, index) => {
    handleFieldChange(event);
  };

  const checkForm = (e) => {
    e.preventDefault();
    const values = [
      heartCondition,
      chestPain,
      pastMonthChestPain,
      dizzinesConsciousnessLoss,
      boneJointProblem,
      bloodPressurePrescription,
      reasonForNoPhysicalAct,
    ];
    const emptyExists = values.some((v) => v === null || v === undefined);
    if (emptyExists) {
      setError(t("signupParq.fillAllOptions"));
      return;
    }
    setError("");
    handleParqInfo(e);
  };

  return (
    <LoginWrapper
      mainClass="Onboarding athlete full-w parq"
      left={
        <form method="POST" data-noreset>
          <section className="mobile-hidden">
            <BackArrowButton onBack={() => onBack(5)} />
            <h1>{t("signupParq.title")}</h1>
            <p>{t("signupParq.intro")}</p>
          </section>
          <header className="only-show-mobile">
            <div>
              <BackArrowButton onBack={() => onBack(5)} />
              <div>
                <h1>{t("signupParq.title")}</h1>
              </div>
            </div>
            <p>{t("signupParq.intro")}</p>
          </header>

          <section>
            {QUESTIONS.map((el, index) => (
              <OnboardingRadio
                key={`${el.name}${index}`}
                label={t(`signupParq.${el.questionKey}`)}
                name={el.name}
                value={el.value}
                options={[
                  { value: "yes", label: t("signupParq.yes") },
                  { value: "no", label: t("signupParq.no"), defaultChecked: true },
                ]}
                onClick={(value) => {
                  changeQuestionValue(
                    { target: { name: el.name, value } },
                    index
                  );
                }}
              />
            ))}
            <p className="text-(--danger)! mt-4">{error}</p>
          </section>

          <button
            data-button-type="primary"
            sz="large"
            onClick={checkForm}
            className="w-1/2! mobile-hidden"
          >
            {t("signupParq.continue")}
          </button>
          <button
            data-button-type="primary"
            sz="large"
            onClick={checkForm}
            className="only-show-mobile"
          >
            {t("signupParq.continue")}
          </button>
        </form>
      }
    />
  );
}

export default SignupParqView;
